if (!customElements.get('compare-table')) {
  customElements.define('compare-table', class CompareTable extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupTable());
      } else {
        this.setupTable();
      }
    }

    setupTable() {
      const compareTableBody = this.querySelector('tbody');
      if (!compareTableBody) return;

      const compareTableRows = compareTableBody.querySelectorAll('tr');
      
      // Add click functionality for rows
      compareTableRows.forEach(row => {
        row.addEventListener('click', function() {
          row.classList.toggle('active');
        });
      });
      
      // Compare values in each row and add fade class if all values are equal
      compareTableRows.forEach(row => {
        const cells = row.querySelectorAll('td:not(:first-child)');
        
        // Skip if row has less than 3 cells (need at least 1 label + 2 values to compare)
        if (cells.length < 3) return;
        
        // Get all values (cells already excludes the first cell which is the label/key)
        const values = Array.from(cells).map(cell => {
          const tdValueElement = cell.querySelector('.td-value');
          return tdValueElement ? tdValueElement.textContent.trim() : '';
        });
        
        // Filter out empty values to get non-empty values
        const nonEmptyValues = values.filter(value => value !== '');
        
        // Check if all values are equal (treating empty as equal to empty)
        let allEqual = false;
        
        if (nonEmptyValues.length === 0) {
          // All values are empty
          allEqual = true;
        } else if (nonEmptyValues.length === values.length) {
          // All values are non-empty, check if they're all the same
          allEqual = nonEmptyValues.every(value => value === nonEmptyValues[0]);
        } else {
          // Mixed empty and non-empty values
          // Check if all non-empty values are the same
          allEqual = nonEmptyValues.every(value => value === nonEmptyValues[0]);
        }
        
        // Add fade class if all values are equal, including cases where:
        // 1. All values are the same non-empty value
        // 2. All values are empty
        // 3. Some values are equal and others are empty
        if (allEqual) {
          row.classList.add('fade-row');
        }
      });
    }
  });
}